export const WSMessageType = {
    IncomingCall: 'incomingCall',
    DropCall: 'dropCall',
    TerminateManualCall: 'terminateManualCall',
    /**
     * Queue health alert (FR-3.1). Unlike the types above it is not addressed to one agent's
     * call: the evaluator fans it out to every connected manager/admin of the tenant.
     */
    QueueDelayAlert: 'queueDelayAlert',
} as const;

export type WSMessageType = (typeof WSMessageType)[keyof typeof WSMessageType];
